import styled from 'styled-components';
export const LoaderWrapper = styled.div.withConfig({
  componentId: "ds__sc-s2b9oe-0"
})(["display:flex;flex:1 0;align-items:center;justify-content:center;"]);
export const LoaderFallbackText = styled.div.withConfig({
  componentId: "ds__sc-s2b9oe-1"
})(["font-size:1rem;"]);